import React from "react";
import Spinner from "./Spinner";

const Loading = ({ show }) => {
  return show ? <Spinner /> : null;
};

export default Loading;
